import { Injector } from '@angular/core';
import { draggableNodeStopEvent } from '@examdojo/core/tiptap';
import { mergeAttributes, Node } from '@tiptap/core';
import { AngularNodeViewRenderer } from 'ngx-tiptap';
import { AccordionComponent } from './accordion.component';
import { ACCORDION_NODE_NAME, ACCORDION_PANEL_NODE_NAME } from './accordion.model';

const accordionClassName = 'accordion-block';

export const AccordionExtension = (injector: Injector) => {
  return Node.create({
    name: ACCORDION_NODE_NAME,
    content: `${ACCORDION_PANEL_NODE_NAME}+`,
    group: 'block',
    defining: true,
    selectable: true,
    draggable: true,

    addAttributes() {
      return {
        custom_css: {
          default: '',
        },
        custom_style: {
          default: null,
        },
        class: {
          renderHTML: (attributes) => {
            const otherClasses = ((attributes['class'] ?? '') as string)
              .split(' ')
              .filter((c) => c !== accordionClassName);
            return { class: `${accordionClassName} ${otherClasses.join(' ')}` };
          },
        },
      };
    },

    parseHTML() {
      return [{ tag: `div.${accordionClassName}` }];
    },

    renderHTML({ HTMLAttributes }) {
      return ['div', mergeAttributes({ class: accordionClassName }, HTMLAttributes), 0];
    },

    addNodeView() {
      return AngularNodeViewRenderer(AccordionComponent, {
        injector,
        stopEvent: draggableNodeStopEvent,
      });
    },
  });
};
